import { HTTP } from '../../utils/http';
import { PaginationParams } from '../../utils/pagination-params';

export const PickupOptionsService = {
    getAllPickupOptions(schoolId) {
        return HTTP.get(`schools/${schoolId}/settings/pick-up-options/all-active`);
    },

    getPickupOptions(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`/schools/${schoolId}/settings/pick-up-options`);
        return HTTP.get(url);
    },

    createPickupOption(schoolId, form) {
        return HTTP.post(`/schools/${schoolId}/settings/pick-up-options`, form);
    },


    addPickupOptionsBulk(schoolId, file) {
        const formData = new FormData();
        formData.append('options-file', file);
        const headers = { 'Content-Type': 'multipart/form-data' };
        return HTTP.post(`schools/${schoolId}/settings/pick-up-options/csv-import`, formData, { headers });
    },

    getPickupOption(schoolId, id) {
        return HTTP.get(`/schools/${schoolId}/settings/pick-up-options/${id}`);
    },

    editPickupOption(schoolId, pickupOptionId, form) {
        return HTTP.patch(`/schools/${schoolId}/settings/pick-up-options/${pickupOptionId}`, form);
    },

    deletePickupOption(schoolId, pickupOptionId) {
        return HTTP.delete(`/schools/${schoolId}/settings/pick-up-options/${pickupOptionId}`);
    },

    deleteMultiplePickupOptions(schoolId, pickupOptionIds) {
        return HTTP.delete(`/schools/${schoolId}/settings/pick-up-options?optionIds=${pickupOptionIds}`);
    },

    togglePickupOptionStatus(schoolId, pickupOptionId) {
        return HTTP.patch(`/schools/${schoolId}/settings/pick-up-options/${pickupOptionId}/toggle`);
    },

    migrateChildren(schoolId, form) {
        return HTTP.put(`/schools/${schoolId}/settings/pick-up-options`, form);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/settings/pickup-options.service.js